<template>
  <div class="d-flex flex-column gap-2 justify-center align-center text-center">
    <template v-if="hasFace">
      <v-icon color="success" size="48">mdi-check-circle</v-icon>
      <h6 class="mb-0">Sua conta já está verificada!</h6>
      <span>Você pode continuar com a solicitação de meia entrada</span>
      <div class="d-flex justify-end w-full mt-4">
        <v-btn color="primary" @click="$emit('next')"> Continuar </v-btn>
      </div>
    </template>
    <template v-else>
      <v-icon color="error" size="48">mdi-close-circle</v-icon>
      <h6 class="mb-0">Sua conta não está verificada</h6>
      <span>
        Para continuar com a solicitação de meia entrada, por favor, faça o
        registro facial
      </span>
      <v-btn
        color="primary"
        :to="{
          path: '/account/face/capture',
          query: { redirect: '/account/concession?init=true' },
        }"
        block
      >
        Validar conta
      </v-btn>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ConcessionBiometryVerify",
  emits: ["next"],
  computed: {
    ...mapGetters("auth", ["user"]),
    hasFace() {
      return this.user?.Biometrics?.find((b) => b.type === "FACE");
    },
  },
};
</script>
